import React from 'react';
import { useGlobalContext } from 'seagull';
import { ConfirmationModal } from 'seagull';
import { useStoreActions } from "../contexts";
import { handlePromise } from "../infra/utils";
const removeLoader = 'dcPM';
export function useDisconnectPaymentMethod() {
  const globalContext = useGlobalContext();
  const {
    api,
    logBI
  } = useStoreActions();
  return async function disconnectPaymentMethod(_ref) {
    let {
      relationshipId,
      isCreditCard,
      last4,
      onSuccess
    } = _ref;
    const confirmed = await globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          textAlignCenter: false,
          title: "Disconnect ".concat(isCreditCard ? 'Credit card' : 'Bank account').concat(last4 ? " ending with ".concat(last4) : '', "?"),
          content: "Please note that payments for invoices generated under this agreement in Anchor will not be processed until a new payment method is connected. Additionally, disconnecting this payment method will only affect this specific agreement and will not impact other agreements it is linked to.",
          skin: "danger",
          primaryButtonLabel: "Disconnect",
          primaryButtonTestid: "disconnect-pm-confirm",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        });
      }
    });
    if (!confirmed) {
      return;
    }
    globalContext.startLoader(removeLoader);
    const {
      success
    } = await handlePromise(api.relationship.disconnectPaymentMethod(relationshipId));
    if (!success) {
      globalContext.showErrorToast('Failed to disconnect payment method', 'disconnect-pm-error');
      return globalContext.stopLoader(removeLoader);
    }
    logBI(10593, {
      relationshipId
    });
    try {
      await onSuccess();
    } finally {
      globalContext.stopLoader(removeLoader);
    }
  };
}